import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/cuenta/login';
import LoginForm from './LoginForm';
import LoadMask from "Utils/LoadMask/LoadMask";
const Logo = require('../../../../../assets/img/logo_bomberos.png');
// Import background to ensure webpack processes it correctly
const LoginBg = require('../../../../../assets/img/login-bg.jpeg');
import './login.css';

class Login extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    };

    render() {
        const { onSubmit, loader } = this.props;
        if (localStorage.getItem('token')) {
            return (<Redirect to="/" />);
        }

        // Inline style for background to avoid CSS path issues
        const backgroundStyle = {
            backgroundImage: `linear-gradient(rgba(36, 59, 139, 0.7), rgba(36, 59, 139, 0.9)), url(${LoginBg})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundAttachment: 'fixed'
        };

        return (
            <div className="vh-100 w-100 d-flex align-items-center justify-content-center justify-content-lg-end pr-lg-5" style={backgroundStyle}>
                <div className="card card-login p-4 p-md-5 mr-lg-5" style={{ maxWidth: '450px', width: '100%', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                    <div className="text-center mb-0">
                        <img className="img-fluid" src={Logo} alt="logo bomberos" style={{ maxWidth: '140px' }} />
                    </div>

                    <LoadMask loading={loader} light>
                        <div className="w-100">
                            {this.props.mustChange ? (
                                <React.Fragment>
                                    <h2 className="text-center font-weight-bold mb-2 text-dark">Cambio de Contraseña</h2>
                                    <p className="text-center text-muted mb-4 small">Es necesario que cambies tu contraseña por seguridad.</p>
                                    <div className="form-group">
                                        <label>Nueva Contraseña</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            onChange={(e) => this.setState({ newPassword: e.target.value })}
                                        />
                                    </div>
                                    <button
                                        className="btn btn-primary btn-block btn-login font-weight-bold"
                                        onClick={() => {
                                            if (this.state.newPassword && this.state.newPassword.length >= 6) {
                                                this.props.onChangePasswordFirstLogin({ newPassword: this.state.newPassword });
                                            } else {
                                                alert("La contraseña debe tener al menos 6 caracteres");
                                            }
                                        }}
                                    >
                                        Cambiar Contraseña
                                    </button>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <h2 className="text-center font-weight-bold mb-2 text-dark" style={{ fontSize: '1.5rem' }}>Bienvenid@ de vuelta</h2>
                                    <p className="text-center text-muted mb-4" style={{ color: '#888' }}>Por favor, ingresa tus credenciales</p>
                                    <LoginForm onSubmit={onSubmit} />
                                </React.Fragment>
                            )}
                        </div>
                    </LoadMask>
                </div>
            </div>
        );
    }
}

const ms2p = (state) => ({
    ...state.login,
});

const md2p = { ...actions };

export default connect(ms2p, md2p)(Login);
